import { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  duration,
  IconButton,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import { customerState, customerStateMange } from "./customerStateMange";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { ApolloClient, InMemoryCache, useMutation } from "@apollo/client";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import _ from "lodash";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import {
  allCustomers,
  customerVisitHistory,
  exportAllPastVisits,
  pastCustomers,
  todayCustomers,
  uploadCustomerList,
} from "./customerData";
import { useEffect } from "react";
import { useLoading } from "../../../context/LodingContext";
import PageLoading from "../../../components/Loading/PageLoading";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import LocationPicker from "../NewCustomer/component/NewCustomerForm/LocationPicker";
import NewLocationPicker from "../NewCustomer/component/NewCustomerForm/NewLocationPicker";
import URL from "../../../pages/Utils/url";
import { exportPastDateProducts } from "../todayProduct/todayProductData";
import { downloadExcelFile } from "../../function/downloadExcel";
import RoleAccess from "../../function/RoleAccess";
import PlaceIcon from "@mui/icons-material/Place";
import { FileUploadModal } from "../../../components/uploadDialog/FileUploadModal";
import TableComponents from "../../../../src/components/tabel/index";
import * as XLSX from "xlsx";
const Customer = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(0);
  const [mapOpen, setMapOpen] = useState(false);
  const [uploadfile, setUploadfile] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const [searchValue, setSearchValue] = useState("");
  const [UpdateFile] = useMutation(uploadCustomerList);
  const { userId } = useAuthData();

  const [cheeckinoutopen, setcheckinoutopen] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);

  const [checkindata, setcheckindata] = useState({
    checkintime: "",
    checkouttime: "",
    duration: "",
    checkin: {
      lat: "",
      log: "",
    },

    checkout: {
      lat: "",
      log: "",
    },
  });

  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();

  const customerListTable = {
    columns: [
      {
        header: "Customer Code",
        accessorKey: "customerCode",
        cell: (props) => <p>{props?.getValue()}</p>,
        meta: {
          sticky: true,
          left: 0,
        },
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        cell: (props) => <p>{props?.getValue()}</p>,
        meta: {
          sticky: true,
          left: 100,
        },
      },
      {
        header: "Customer Category",
        accessorKey: "customerCategory",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Rep Name",
        accessorKey: "repName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Rep Code",
        accessorKey: "repCode",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Customer Status",
        accessorKey: "customerStatus",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Create Date",
        accessorKey: "createdAt",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      customerCategory: _.capitalize(v?.customerCategory),
      customerCode: v?.customerCode,
      customerName: _.capitalize(v?.customerName),
      priceCode: v?.priceCode,
      repName: _.capitalize(v?.repName),
      repCode: _.capitalize(v?.repCode),
      status: (
        <p
          style={{
            color:
              v?.status?.toLowerCase() == "completed" ? "#2a9941" : "orange",
            marginTop: "10px",
            fontWeight: "600",
          }}
        >
          {_.startCase(_.toLower(v?.status?.replace(/_/g, " ")))}
        </p>
      ),
      customerStatus: (
        <p
          style={{
            color:
              v?.customerStatus?.toLowerCase() == "active" ? "#2a9941" : "red",
            marginTop: "10px",
            fontWeight: "600",
          }}
        >
          {_.startCase(_.toLower(v?.customerStatus?.replace(/_/g, " ")))}
        </p>
      ),
      createdBy: v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),
      Action: (
        <div
          style={{
            display: "flex",
            // justifyContent: "space-evenly",
            marginTop: "5px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Visit Customer Screen"
            component="ViewVisitCustomer"
          >
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/visit-customer/view-customer`, {
                  state: { type: "view", data: v, rowId: v?.id },
                })
              }
            />
          </RoleAccess>
          {value == 0 && (
            <RoleAccess
              modelName="Visit Customer Screen"
              component="UpdateVisitCustomer"
            >
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/visit-customer/edit-customer`, {
                    state: { type: "edit", data: v, rowId: v?.id },
                  })
                }
              />
            </RoleAccess>
          )}

          <LocationOnIcon
            fontSize="small"
            className="actionIcon"
            onClick={() => handleLocation(v?.id)}
          />

          {/* <DeleteIcon
              style={{ color: "GrayText", fontSize: "20px" }}
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };

  useEffect(() => {
    setData([]);

    if (value == 0) {
      fetchTodatCustomer();
    } else if (value == 1) {
      fetchPastCustomer();
    }
  }, [value, pagination, searchValue]);

  const fetchTodatCustomer = () => {
    setIsLoading(true);
    request(BASEURL, todayCustomers, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
    })
      .then((res) => {
        console.log(res, "res");

        const success = res?.todayCustomers?.success;
        const totalCount = res?.todayCustomers?.totalCount;
        const totalPages = res?.todayCustomers?.totalPages;

        if (success) {
          setData(res?.todayCustomers?.customers);
          setDataCount({
            pageCount: totalPages,
            itemCount: totalCount,
          });
        } else {
          setData([]);
          setDataCount({
            pageCount: 0,
            itemCount: 0,
          });
        }
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  const fetchPastCustomer = () => {
    setIsLoading(true);
    request(BASEURL, pastCustomers, {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      search: searchValue,
    })
      .then((res) => {
        const success = res?.pastCustomers?.success;
        const totalCount = res?.pastCustomers?.totalCount;
        const totalPages = res?.pastCustomers?.totalPages;

        if (success) {
          setData(res?.pastCustomers?.customers);
          setDataCount({
            pageCount: totalPages,
            itemCount: totalCount,
          });
        } else {
          setData([]);
          setDataCount({
            pageCount: 0,
            itemCount: 0,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleTabChange = (event, newValue) => {
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setValue(newValue);
  };

  const handleLocation = async (id) => {
    setCirleLoading(true);

    try {
      const response = await request(BASEURL, customerVisitHistory, {
        customerid: String(id),
      });

      const data = response?.customerVisitHistory;

      if (data?.length) {
        // setMapOpen(true);

        setcheckindata({
          checkintime: data[0]?.checkInTime,
          checkouttime: data[0]?.checkOutTime,
          checkin: {
            lat: data[0]?.checkinLat,
            log: data[0]?.checkinLng,
          },

          checkout: {
            lat: data[0]?.checkoutLat,
            log: data[0]?.checkoutLng,
          },
          duration: data[0]?.duration,
        });
        setcheckinoutopen(true);
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: "Sales Person Hasn't Checked In",
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleExcelUpload = async (file) => {
    setUploadStatus(false);
    setCirleLoading(true);
    try {
      const response = await UpdateFile({
        variables: {
          file: file,
          userId: userId,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.uploadCustomerList?.success;
      const message = response?.data?.uploadCustomerList?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchTodatCustomer(pagination.pageIndex + 1);
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "File upload failed!",
        text: error.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownload = () => {
    setCirleLoading(true);
    request(BASEURL, exportAllPastVisits).then(async (res) => {
      const status = res?.exportAllPastVisits?.success;
      const message = res?.exportAllPastVisits?.message;
      const pdfurl = `${URL}${res?.exportAllPastVisits?.fileUrl?.slice(1)}`;

      if (status) {
        const status = await downloadExcelFile(pdfurl, "Visit_Customer.xlsx");
        setCirleLoading(false);
      } else {
        setCirleLoading(false);
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,

          showConfirmButton: true,
        });
      }
    });
  };

  const handleSampleExcelDownload = () => {
    const headers = [
      [
        "CATEGORY",
        "RepCode",
        "RepName",
        "CustomerCode",
        "CustomerName",
        "CreditLimit",
        "CreditPeriod",
        "BALANCE",
        "STATUS",
        "PRICECODE",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(headers);
    worksheet["!cols"] = [
      { wch: 16 },
      { wch: 14 },
      { wch: 20 },
      { wch: 16 },
      { wch: 22 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 12 },
      { wch: 14 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Visit_Customer_Sample");
    XLSX.writeFile(workbook, "Visit_Customer_Sample.xlsx");

    Swal.fire({
      position: "top",
      icon: "success",
      title: "Sample Excel Downloaded Successfully",
      showConfirmButton: true,
    });
  };

  const handleUploadClick = () => {
    setUploadStatus(false);
    setTimeout(() => setUploadStatus(true), 0);
  };

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  return (
    <DashboardLayout>
      <Dialog open={cheeckinoutopen} onClose={() => setcheckinoutopen(false)}>
        <DialogTitle
          sx={{
            backgroundColor: "#2a9941",
            color: "white",
            fontWeight: "bold",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          Check-In & Check-Out Details
        </DialogTitle>

        <DialogContent
          sx={{
            backgroundColor: "#f9f9f9",
            padding: "20px",
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: "0 10px",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#e3f2fd", borderRadius: 10 }}>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-in{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkin?.lat,
                        lng: checkindata?.checkin?.log,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="primary" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Check-out{" "}
                  <IconButton
                    onClick={() => {
                      setSelectedLocation({
                        lat: checkindata?.checkout?.lat,
                        lng: checkindata?.checkout?.log,
                      });
                      setMapOpen(true);
                    }}
                    size="small"
                  >
                    <PlaceIcon fontSize="small" color="error" />
                  </IconButton>
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderRadius: 8,
                  }}
                >
                  Duration
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.2s",
                  borderRadius: 10,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.01)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkintime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.checkouttime || "—"}
                </td>
                <td style={{ padding: "10px 15px" }}>
                  {checkindata?.duration || "—"}
                </td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
      </Dialog>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Visit Customer List
                </MaterialTypography>
              </Stack>
              <Box sx={{ width: "25%", bgcolor: "background.paper" }}>
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: "#2a9941",
                      color: "white",
                    },
                  }}
                  centered
                >
                  <Tab label="Current" />
                  <Tab label="Past " />
                </Tabs>
              </Box>
              <RoleAccess
                modelName="Visit Customer Screen"
                component="ExportVisitCustomer"
              >
                {data?.length > 0 && (
                  <button
                    className="container-btn-file"
                    onClick={handleDownload}
                    style={{
                      height: "38px",
                      marginLeft: "0",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                    </svg>
                    Export File
                  </button>
                )}
              </RoleAccess>
              {value == 0 && (
                <button
                  className="container-btn-file"
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={handleSampleExcelDownload}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Sample Excel
                </button>
              )}
              {value == 0 && (
                <RoleAccess
                  modelName="Visit Customer Screen"
                  component="UploadVisitCustomer"
                >
                  <label
                    className="container-btn-file"
                    style={{
                      height: "38px",
                      marginLeft: "0",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => handleUploadClick()} // show the modal
                  >
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 50 50"
                    >
                      <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                    </svg>
                    Upload File
                  </label>
                </RoleAccess>
              )}

              <RoleAccess
                modelName="Visit Customer Screen"
                component="CreateVisitCustomer"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/visit-customer/add-customer", {
                      state: { type: "add" },
                    })
                  }
                >
                  Customer
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        <NewLocationPicker
          open={mapOpen}
          onClose={() => setMapOpen(false)}
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
        />

        {uploadStatus && (
          <FileUploadModal
            key={Date.now()} // force remount
            status={uploadStatus}
            onClose={() => setUploadStatus(false)}
            onSubmit={(file) => handleExcelUpload(file)}
            onDownloadSample={handleSampleExcelDownload}
          />
        )}
        <TableComponents
          rows={customerListTable?.rows}
          columns={customerListTable?.columns}
          pagination={pagination}
          setPagination={setPagination}
          pageCount={dataCount.pageCount}
          recordCount={dataCount.itemCount}
          isLoading={isLoading}
          isSearch={true}
          onChange={handleSearch}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Customer;
